/**
 * CardCaptureStep - Step 5: Payment card capture
 */
import { Elements } from '@stripe/react-stripe-js';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { CreditCard, Shield, ArrowLeft, AlertCircle } from 'lucide-react';
import CardCaptureForm from './CardCaptureForm';

export const CardCaptureStep = ({ 
  stripePromise,
  pendingId,
  studentName,
  totalClasses,
  totalAmount,
  onSuccess,
  onBack,
  onError
}) => {
  const handleError = (errorType) => {
    if (errorType === 'pending_not_found') {
      toast.error('Registration session expired. Please restart.');
      onError(errorType);
    }
  };

  return (
    <Card className="bg-white/5 border-white/10">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <CreditCard className="w-5 h-5 text-[#FF007F]" />
          Payment Details
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="p-4 bg-[#FF007F]/10 rounded-lg border border-[#FF007F]/30 mb-4">
          <p className="text-sm text-white/90">
            <Shield className="w-4 h-4 inline mr-1" />
            Your card will be securely saved. Payment will only be taken after admin authorization.
          </p>
        </div>

        <div className="p-4 bg-white/5 rounded-lg mb-4">
          <div className="flex justify-between text-sm mb-1">
            <span className="text-white/70">Classes selected</span>
            <span className="text-white">{totalClasses}</span>
          </div>
          <div className="flex justify-between font-semibold">
            <span className="text-white">Total</span>
            <span className="text-[#FF007F]">£{totalAmount.toFixed(2)}</span>
          </div>
        </div>

        {!pendingId ? (
          <div className="p-4 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-center">
            <AlertCircle className="w-6 h-6 mx-auto mb-2" />
            <p>Registration session not found. Please go back and complete the previous steps.</p>
            <Button
              variant="outline"
              onClick={onBack}
              className="mt-4 border-red-500/30 text-red-400 hover:bg-red-500/10"
            >
              Go Back
            </Button>
          </div>
        ) : (
          <Elements stripe={stripePromise}>
            <CardCaptureForm 
              onSuccess={onSuccess}
              pendingId={pendingId}
              studentName={studentName}
              onError={handleError}
            />
          </Elements>
        )}

        <Button 
          variant="outline" 
          onClick={onBack} 
          className="w-full border-white/10 text-white hover:bg-white/10"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Back
        </Button>
      </CardContent>
    </Card>
  );
};

export default CardCaptureStep;
